import { CommonContext } from "@src/context"
import React, { useContext } from "react"

const ResponsiveContent = ({ children = null, mobile }) => {
  const { isMobileLayout } = useContext(CommonContext)
  if (isMobileLayout === undefined) {
    return <div style={{ height: 200 }} />
  }
  return isMobileLayout && mobile ? mobile() : children
}

export default ResponsiveContent
